module.exports = __webpack_public_path__ + "images/fifth_anniversary/step2-number-icon_477afe2d516e6c198c3d84b70395d0a3.png";